import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAlertsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetAlertsQuery = {
  __typename?: 'Query';
  alerts: {
    __typename?: 'AlertConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'AlertEdge';
      cursor: string;
      node: {
        __typename?: 'Alert';
        id: any;
        name: string;
        description?: string | null;
        status: Types.AlertStatus;
        triggerCount: number;
        lastTriggeredAt?: any | null;
        createdAt: any;
        updatedAt: any;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasPreviousPage: boolean;
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export const GetAlertsDocument = gql`
  query GetAlerts($after: String, $before: String, $first: Int, $last: Int) {
    alerts(after: $after, before: $before, first: $first, last: $last) {
      totalCount
      edges {
        cursor
        node {
          id
          name
          description
          status
          triggerCount
          lastTriggeredAt
          createdAt
          updatedAt
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
`;

/**
 * __useGetAlertsQuery__
 *
 * To run a query within a React component, call `useGetAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetAlertsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAlertsQuery,
    GetAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAlertsQuery, GetAlertsQueryVariables>(
    GetAlertsDocument,
    options,
  );
}
export function useGetAlertsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAlertsQuery,
    GetAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAlertsQuery, GetAlertsQueryVariables>(
    GetAlertsDocument,
    options,
  );
}
export function useGetAlertsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAlertsQuery, GetAlertsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAlertsQuery, GetAlertsQueryVariables>(
    GetAlertsDocument,
    options,
  );
}
export type GetAlertsQueryHookResult = ReturnType<typeof useGetAlertsQuery>;
export type GetAlertsLazyQueryHookResult = ReturnType<
  typeof useGetAlertsLazyQuery
>;
export type GetAlertsSuspenseQueryHookResult = ReturnType<
  typeof useGetAlertsSuspenseQuery
>;
export type GetAlertsQueryResult = Apollo.QueryResult<
  GetAlertsQuery,
  GetAlertsQueryVariables
>;
